module.exports = __webpack_public_path__ + "img/mockup-mobile-1.78d59c40.jpg";